module.exports = __webpack_public_path__ + "static/img/qh1-2.3d86c3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/qh1-2.png
// module id = 702
// module chunks = 0